/* OMNÉA Anprobe (01.11.2026) – Verhalten zu sections/omnea-anprobe.liquid.
   Für dich: liest die Popup-Antwort (sessionStorage owp_ziel) bzw. die hier getippte Antwort (omnea_anprobe_ziel).
   Licht: Farbwechsel ohne Neuladen. Spiegel: oben/unten wischen, Farbe + Größe je Teil, beide Teile in den Warenkorb. */
(function () {
  var EUR = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var EU = { XS: 34, S: 36, M: 38, L: 40, XL: 42, XXL: 44 };
  var SCHLUESSEL = 'omnea_anprobe_ziel';
  var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lesen(speicher, k) { try { return window[speicher].getItem(k); } catch (e) { return null; } }
  function schreiben(speicher, k, v) { try { window[speicher].setItem(k, v); } catch (e) {} }
  function kurz(name) { return String(name || '').replace(/^OMN[ÉE]A\s+/i, ''); }

  function starten(s) {
    if (s.dataset.oanAn) return;
    s.dataset.oanAn = '1';
    var datenEl = s.querySelector('[data-oan-daten]');
    if (!datenEl) return;
    var D;
    try { D = JSON.parse(datenEl.textContent); } catch (e) { return; }
    var $ = function (q) { return s.querySelector(q); };
    var eu = s.dataset.eu === 'true';
    var grenze = parseInt(s.dataset.grenze, 10) || 5000;
    var produktId = parseInt(s.dataset.produkt, 10);
    var schublade = function () {
      return window.omneaSchublade && typeof window.omneaSchublade.zeigen === 'function' ? window.omneaSchublade : null;
    };

    function groessenBauen(box, varianten, name, gewaehlt, beiWahl) {
      var legende = box.querySelector('legend');
      box.textContent = '';
      if (legende) box.append(legende);
      varianten.forEach(function (v) {
        var label = document.createElement('label');
        label.className = 'oan__gr';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = name;
        input.value = v.id;
        input.disabled = !v.ok;
        input.checked = v.ok && String(v.id) === String(gewaehlt);
        if (name === 'id') input.required = true;
        var span = document.createElement('span');
        span.textContent = v.g;
        if (eu && EU[v.g]) { var sm = document.createElement('small'); sm.textContent = EU[v.g]; span.append(sm); }
        label.setAttribute('aria-label', 'Größe ' + v.g + (v.ok ? '' : ', ausverkauft'));
        input.addEventListener('change', function () { beiWahl(v); });
        label.append(input, span);
        box.append(label);
      });
    }

    function inDenKorb(ids, knopf, status, text) {
      var sch = schublade();
      var daten = { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) };
      if (sch) { daten.sections = 'omnea-schublade'; daten.sections_url = location.pathname; }
      knopf.disabled = true;
      status.textContent = '';
      fetch(D.warenkorb + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(daten) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          knopf.disabled = false;
          if (d.status) { status.textContent = d.description || 'Das geht gerade nicht. Bitte wähle eine andere Größe.'; return; }
          if (!sch) { location.href = D.korb; return; }
          status.textContent = text;
          setTimeout(function () { if (status.textContent === text) status.textContent = ''; }, 4000);
          sch.setActiveElement(knopf);
          sch.zeigen(d);
        })
        .catch(function () { knopf.disabled = false; status.textContent = 'Keine Verbindung. Bitte versuch es noch einmal.'; });
    }

    /* ---------- 2 · Licht ---------- */
    var L = { teil: D.licht, f: 0, bild: 0, varId: null };
    L.teil.farben.forEach(function (f, i) { if (f.pid === produktId && L.f === 0) L.f = i; });
    var img = $('[data-oan-img]');
    var bildKnopf = $('[data-oan-bild]');
    var kauf = $('[data-oan-kauf]');
    var statusKauf = $('[data-oan-status]');

    function raumBild() {
      var f = L.teil.farben[L.f];
      if (!img || !f || !f.bilder.length) return;
      var n = f.bilder.length;
      L.bild = L.bild % n;
      var src = f.bilder[L.bild];
      var h = $('[data-oan-hinweis]');
      if (h) { h.hidden = n < 2; h.textContent = 'Antippen für das nächste Bild · ' + (L.bild + 1) + ' / ' + n; }
      if (img.getAttribute('src') === src) return;
      var neu = new Image();
      neu.onload = function () {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        img.alt = L.teil.titel + ' in ' + f.name + ', Bild ' + (L.bild + 1) + ' von ' + n;
        img.classList.remove('weg');
      };
      if (!ruhig) img.classList.add('weg');
      setTimeout(function () { neu.src = src; }, ruhig ? 0 : 200);
    }
    /* Bausteine der Produktseite (Bestand, Merken, Passt gut zusammen …) für die neue Farbe nachladen und die Adresse umsetzen */
    var ladeNr = 0;
    function bausteineHolen(url) {
      if (!url || !D.abschnitt) return;
      var nr = ++ladeNr;
      var mitAnsicht = D.ansicht && /[?&]view=/.test(location.search);
      try { history.replaceState(history.state, '', url + (mitAnsicht ? (url.indexOf('?') < 0 ? '?' : '&') + 'view=' + encodeURIComponent(D.ansicht) : '')); } catch (e) {}
      /* Produktbühne (sections/omnea-buehne) weiter unten wechselt mit */
      var buehnen = [];
      document.querySelectorAll('.obn').forEach(function (el) {
        var w = el.closest('.shopify-section');
        if (w && w.id.indexOf('shopify-section-') === 0) buehnen.push(w.id.slice(16));
      });
      var adresse = url + (url.indexOf('?') < 0 ? '?' : '&') + (D.ansicht ? 'view=' + encodeURIComponent(D.ansicht) + '&' : '') + 'sections=' + [D.abschnitt].concat(buehnen).map(encodeURIComponent).join(',');
      fetch(adresse) /* ohne Accept: application/json, sonst liefert Shopify das Produkt-JSON statt der Abschnitte */
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (teile) {
          if (nr !== ladeNr) return;
          var leser = new DOMParser();
          if (teile[D.abschnitt]) {
            var doc = leser.parseFromString(teile[D.abschnitt], 'text/html');
            s.querySelectorAll('[data-oan-slot]').forEach(function (slot) {
              var neu = doc.querySelector('[data-oan-slot="' + slot.getAttribute('data-oan-slot') + '"]');
              if (!neu) return;
              slot.innerHTML = neu.innerHTML;
              slot.querySelectorAll('script').forEach(function (alt) {
                var sc = document.createElement('script');
                Array.prototype.forEach.call(alt.attributes, function (a) { sc.setAttribute(a.name, a.value); });
                sc.textContent = alt.textContent;
                alt.parentNode.replaceChild(sc, alt);
              });
            });
          }
          buehnen.forEach(function (id) {
            var huelle = document.getElementById('shopify-section-' + id);
            if (!teile[id] || !huelle) return;
            var neu = leser.parseFromString(teile[id], 'text/html').getElementById('shopify-section-' + id);
            if (!neu) return;
            neu.querySelectorAll('script[src]').forEach(function (sc) { sc.remove(); });
            huelle.innerHTML = neu.innerHTML;
            huelle.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: id, load: true } }));
          });
        })
        .catch(function () {});
    }
    function lichtZeigen(neuGewaehlt) {
      var f = L.teil.farben[L.f];
      if (!f) return;
      s.style.setProperty('--oan-farbe', f.hex);
      var wort = $('[data-oan-wort]'); if (wort) wort.textContent = kurz(f.name).toUpperCase();
      var fn = $('[data-oan-farbname]'); if (fn) fn.textContent = f.name;
      s.querySelectorAll('[data-oan-punkte="licht"] .oan__punkt').forEach(function (a, i) {
        if (i === L.f) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      if (neuGewaehlt) {
        var alt = L.varId ? groesseVon(L.varId) : null;
        var gleich = alt && f.var.filter(function (v) { return v.g === alt && v.ok; })[0];
        L.varId = gleich ? gleich.id : null;
      }
      var gr = $('[data-oan-groessen]');
      if (gr) groessenBauen(gr, f.var, 'id', L.varId, function (v) { L.varId = v.id; preisZeigen(v.preis); statusKauf.textContent = ''; });
      var v0 = f.var.filter(function (v) { return String(v.id) === String(L.varId); })[0] || f.var[0];
      if (v0) preisZeigen(v0.preis);
      raumBild();
    }
    function groesseVon(id) {
      var g = null;
      L.teil.farben.forEach(function (f) { f.var.forEach(function (v) { if (String(v.id) === String(id)) g = v.g; }); });
      return g;
    }
    function preisZeigen(cent) { var p = $('[data-oan-preis]'); if (p) p.textContent = EUR.format(cent / 100); }

    s.querySelectorAll('[data-oan-punkte="licht"] .oan__punkt').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var i = parseInt(a.dataset.index, 10) || 0;
        if (i === L.f) return;
        var vorher = L.teil.farben[L.f].name;
        L.f = i;
        L.bild = 0;
        if (vorher && document.title.indexOf(vorher) >= 0) document.title = document.title.replace(vorher, L.teil.farben[i].name);
        statusKauf.textContent = '';
        lichtZeigen(true);
        bausteineHolen(L.teil.farben[i].url);
      });
    });
    if (bildKnopf) bildKnopf.addEventListener('click', function () { L.bild += 1; raumBild(); });
    if (kauf) kauf.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = kauf.querySelector('input[name="id"]:checked');
      if (!r) { statusKauf.textContent = 'Bitte wähle zuerst deine Größe.'; return; }
      inDenKorb([parseInt(r.value, 10)], $('[data-oan-knopf]'), statusKauf, 'Liegt im Warenkorb.');
    });

    /* ---------- 3 · Spiegel ---------- */
    var R = { oben: { liste: D.oben || [], i: 0, f: '', varId: null }, unten: { liste: D.unten || [], i: 0, f: '', varId: null } };
    var hatSpiegel = !!$('[data-oan-reihe]') && R.oben.liste.length && R.unten.liste.length;

    function farbeIn(teil, wunsch) {
      var i = -1;
      teil.farben.forEach(function (f, k) { if (i < 0 && wunsch && kurz(f.name).toLowerCase() === kurz(wunsch).toLowerCase()) i = k; });
      return i < 0 ? 0 : i;
    }
    function reiheZeigen(reihe, rollen) {
      var r = R[reihe];
      var box = s.querySelector('[data-oan-reihe="' + reihe + '"]');
      var spur = box.querySelector('[data-oan-spur]');
      var folien = spur.children;
      r.liste.forEach(function (teil, k) {
        var f = teil.farben[farbeIn(teil, r.f)];
        var bild = folien[k] && folien[k].querySelector('img');
        if (bild && f && f.bilder[0] && bild.getAttribute('src') !== f.bilder[0]) {
          bild.removeAttribute('srcset');
          bild.removeAttribute('sizes');
          bild.src = f.bilder[0];
          bild.alt = teil.titel + ' in ' + f.name;
        }
      });
      if (rollen) spur.scrollTo({ left: r.i * spur.clientWidth, behavior: 'auto' });
      var z = box.querySelector('[data-oan-zaehler]');
      if (z.children.length !== r.liste.length) { z.textContent = ''; r.liste.forEach(function () { z.append(document.createElement('i')); }); }
      Array.prototype.forEach.call(z.children, function (d, k) { d.classList.toggle('an', k === r.i); });

      var teil = r.liste[r.i];
      var fi = farbeIn(teil, r.f);
      var f = teil.farben[fi];
      var wahl = s.querySelector('[data-oan-wahl="' + reihe + '"]');
      wahl.querySelector('[data-oan-name]').textContent = teil.titel;
      var v0 = f.var.filter(function (v) { return v.ok; })[0] || f.var[0];
      wahl.querySelector('[data-oan-info]').textContent = [teil.art, f.name, EUR.format((v0 ? v0.preis : 0) / 100)].filter(Boolean).join(' · ');
      var punkte = wahl.querySelector('[data-oan-punkte]');
      punkte.textContent = '';
      teil.farben.forEach(function (x, k) {
        if (teil.farben.length < 2) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oan__punkt';
        b.style.setProperty('--c', x.hex);
        b.title = x.name;
        b.setAttribute('aria-label', x.name);
        b.setAttribute('aria-pressed', k === fi ? 'true' : 'false');
        b.append(document.createElement('span'));
        b.addEventListener('click', function () { r.f = x.name; r.varId = null; reiheZeigen(reihe, false); summeZeigen(); });
        punkte.append(b);
      });
      if (r.varId && !f.var.some(function (v) { return String(v.id) === String(r.varId) && v.ok; })) r.varId = null;
      groessenBauen(wahl.querySelector('[data-oan-groessen]'), f.var, 'oan-' + reihe + '-' + s.id, r.varId, function (v) {
        r.varId = v.id; $('[data-oan-status-beide]').textContent = '';
      });
    }
    function preisVon(reihe) {
      var r = R[reihe];
      var teil = r.liste[r.i];
      var f = teil.farben[farbeIn(teil, r.f)];
      var v = f.var.filter(function (x) { return String(x.id) === String(r.varId); })[0] || f.var.filter(function (x) { return x.ok; })[0] || f.var[0];
      return { teil: teil, f: f, preis: v ? v.preis : 0 };
    }
    function summeZeigen() {
      var ges = 0;
      ['oben', 'unten'].forEach(function (reihe) {
        var p = preisVon(reihe);
        s.querySelector('[data-oan-summe="' + reihe + '"]').textContent = p.teil.titel + (p.f.name ? ' · ' + kurz(p.f.name) : '');
        s.querySelector('[data-oan-summe-preis="' + reihe + '"]').textContent = EUR.format(p.preis / 100);
        ges += p.preis;
      });
      $('[data-oan-summe-ges]').textContent = EUR.format(ges / 100);
      $('[data-oan-versand]').textContent = ges >= grenze
        ? 'Ab ' + EUR.format(grenze / 100).replace(',00', '') + ' versandkostenfrei in Deutschland. Mit beiden Teilen bist du drüber.'
        : 'Noch ' + EUR.format((grenze - ges) / 100) + ' bis zum kostenlosen Versand.';
    }
    function spiegelZeigen() {
      reiheZeigen('oben', true);
      reiheZeigen('unten', true);
      summeZeigen();
      var st = $('[data-oan-status-beide]'); if (st) st.textContent = '';
    }
    if (hatSpiegel) {
      ['oben', 'unten'].forEach(function (reihe) {
        var box = s.querySelector('[data-oan-reihe="' + reihe + '"]');
        var spur = box.querySelector('[data-oan-spur]');
        var t;
        spur.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var n = R[reihe].liste.length;
            var i = Math.max(0, Math.min(n - 1, Math.round(spur.scrollLeft / spur.clientWidth)));
            if (i !== R[reihe].i) { R[reihe].i = i; R[reihe].varId = null; reiheZeigen(reihe, false); summeZeigen(); }
          }, 80);
        }, { passive: true });
        box.querySelectorAll('.oan__pfeil').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = R[reihe].liste.length;
            var i = (R[reihe].i + parseInt(b.dataset.schritt, 10) + n) % n;
            R[reihe].i = i;
            R[reihe].varId = null;
            spur.scrollTo({ left: i * spur.clientWidth, behavior: ruhig ? 'auto' : 'smooth' });
            reiheZeigen(reihe, false);
            summeZeigen();
          });
        });
      });
      $('[data-oan-beide]').addEventListener('click', function () {
        var st = $('[data-oan-status-beide]');
        if (!R.oben.varId || !R.unten.varId) {
          st.textContent = !R.oben.varId && !R.unten.varId ? 'Bitte wähle oben und unten deine Größe.' : (!R.oben.varId ? 'Bitte wähle noch die Größe oben.' : 'Bitte wähle noch die Größe unten.');
          return;
        }
        inDenKorb([parseInt(R.oben.varId, 10), parseInt(R.unten.varId, 10)], this, st, 'Beide Teile liegen im Warenkorb.');
      });
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { reiheZeigen('oben', true); reiheZeigen('unten', true); }, 150); });
    }

    /* ---------- 1 · Für dich ---------- */
    var ziele = D.ziele || {};
    function teilMit(reihe, pid, wunsch) {
      var treffer = null;
      R[reihe].liste.forEach(function (teil, k) {
        if (treffer) return;
        teil.farben.forEach(function (f) { if (!treffer && f.pid === pid) treffer = { i: k, f: wunsch || f.name }; });
      });
      return treffer;
    }
    function zielSetzen(z, sanft) {
      var d = ziele[z];
      var eingang = $('[data-oan-eingang]');
      var titel = d ? d.titel : D.standard.titel;
      var text = d ? (d.text || D.standard.text) : D.standard.text;
      var tun = function () {
        $('[data-oan-titel]').textContent = titel;
        $('[data-oan-lead]').textContent = text;
        eingang.classList.remove('wechselt');
      };
      if (sanft && !ruhig) { eingang.classList.add('wechselt'); setTimeout(tun, 280); } else tun();
      var warum = $('[data-oan-warum]');
      if (warum) warum.textContent = d
        ? 'Weil du „' + d.wort + '“ gesagt hast. Du kannst es hier jederzeit ändern.'
        : (z === '' ? 'Du hast nichts angegeben. Die Anprobe bleibt neutral.' : 'Wofür trainierst du? Tipp an, dann passt sich die Anprobe an.');
      s.querySelectorAll('.oan__chip').forEach(function (c) { c.setAttribute('aria-pressed', z !== null && c.dataset.ziel === z ? 'true' : 'false'); });
      if (!hatSpiegel) return;
      var o = d && teilMit('oben', d.oben, d.oben_farbe);
      var u = d && teilMit('unten', d.unten, d.unten_farbe);
      R.oben.i = o ? o.i : 0; R.oben.f = o ? o.f : ''; R.oben.varId = null;
      R.unten.i = u ? u.i : 0; R.unten.f = u ? u.f : ''; R.unten.varId = null;
      spiegelZeigen();
      var sw = $('[data-oan-spiegel-warum]');
      if (sw) {
        var ot = R.oben.liste[R.oben.i].titel, ut = R.unten.liste[R.unten.i].titel;
        sw.textContent = d && d.fuer ? 'Für ' + d.fuer + ' legen wir dir zuerst hin: ' + ot + ' und ' + ut + '.' : '';
      }
    }
    s.querySelectorAll('.oan__chip').forEach(function (c) {
      c.addEventListener('click', function () {
        var z = c.dataset.ziel;
        schreiben('sessionStorage', SCHLUESSEL, z);
        schreiben('localStorage', SCHLUESSEL, z);
        zielSetzen(z, true);
      });
    });

    /* Start: eigene Antwort hier > Popup-Antwort dieser Sitzung > gemerkte Antwort */
    var start = lesen('sessionStorage', SCHLUESSEL);
    if (start === null) {
      var popup = lesen('sessionStorage', 'owp_ziel');
      if (popup) { start = popup; schreiben('localStorage', SCHLUESSEL, popup); }
    }
    if (start === null) start = lesen('localStorage', SCHLUESSEL);
    if (start !== null && start !== '' && !ziele[start]) start = null;
    lichtZeigen(false);
    zielSetzen(start, false);
    s.classList.add('ist-bereit');
  }

  function alle() { document.querySelectorAll('[data-oan]').forEach(starten); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();
